module.exports = __webpack_public_path__ + "img/892ba14.svg";